// extracted by mini-css-extract-plugin
export default {"heading":"Xs-z","corrected":"Ys-z","redirectVerbiageContainer":"Zs-z","redirectVerbiageText":"_s-z"};